import type { StringGUID } from "@pdfking/tfunc"

import type { MetaFile } from "../base/MetaFile"
import type { ContentType } from "../ContentType"
import type { VirtualFileType } from "../VirtualFileType"

export type RemoteFile = {
  readonly enum: VirtualFileType.REMOTE_FILE
  readonly guid: StringGUID
  readonly type: ContentType
  readonly mirrors: string[]
} & MetaFile
